import { type JSX } from 'react';
import { generatePath } from 'react-router';

import { Link } from 'Components/Buttons/Buttons';
import { CollapsibleModal } from 'Components/Modal/CollapsibleModal/CollapsibleModal';
import { Text } from 'Components/Text/Text';
import { RISK_DETAILS } from 'Config/PathTemplates';
import { RiskResponse } from 'Models/RiskRegister';

import styles from './RiskRegisterDashboard.module.css';

export interface RiskModalProps {
    hideModal: () => void;
    risks: RiskResponse[];
    showImpactAndProbability?: boolean;
}

export const RiskModal = (props: RiskModalProps): JSX.Element => {
    const formattedRisks = props.risks.map((risk) => {
        return (
            <div key={risk.id} className={styles.modalRow}>
                <Link openInNewTab size="sm" to={generatePath(RISK_DETAILS, { risk_id: risk.id })}>
                    {risk.title}
                </Link>
                {props.showImpactAndProbability !== false && (
                    <div className={styles.modalRowSeparator}>
                        <Text color="darkGray" noStyles={true}>
                            {`Impact: ${risk.current_risk_impact} | Probability: ${risk.current_risk_probability}`}
                        </Text>
                    </div>
                )}
            </div>
        );
    });

    return <CollapsibleModal hideModal={props.hideModal} displayItems={formattedRisks} headerText={{ text: 'Risks' }} />;
};
